import React from 'react'

import EmptyGuide from 'Icons/empty-guides.svg'

import NoContent from 'Layout/NoContent'

const noContentProps = {
  heading: 'Guides help you simplify your articles into steps',
  description:
    'With guides, you can help your users troubleshoot their issues with bite-sized support content in a step-by-step manner.',
  ctaButtonText: 'Create a new guide',
  icon: EmptyGuide,
  ctaTarget: 'create'
}

const NoGuides = () => {
  return <NoContent {...noContentProps} />
}

export default NoGuides
